import { Group } from '@mantine/core';
import type { IconNames } from '@repo/foundations';
import { Icon, Text } from '@repo/foundations';
import type { ColorNames } from '@repo/theme/utils';
import { AUTOMATION_JOB_STATUS } from './utils';

const StatusColorMap: Record<
	AUTOMATION_JOB_STATUS,
	{
		iconName: IconNames;
		iconColor?: ColorNames;
		iconFillColor?: ColorNames;
		label: string;
	}
> = {
	[AUTOMATION_JOB_STATUS.FAILED]: {
		iconName: 'alertCircleFilled',
		iconFillColor: 'icon/critical/default',
		label: 'Failed',
	},
	[AUTOMATION_JOB_STATUS.COMPLETED]: {
		iconName: 'circleCheckFilled',
		iconFillColor: 'icon/success/default',
		label: 'Completed',
	},
	[AUTOMATION_JOB_STATUS.RUNNING]: {
		iconName: 'loader2',
		iconColor: 'icon/primary/default',
		label: 'Running',
	},
	[AUTOMATION_JOB_STATUS.REVERTED]: {
		iconName: 'arrowBackUp',
		iconColor: 'icon/primary/default',
		label: 'Reverted',
	},
	[AUTOMATION_JOB_STATUS.DISCARDED]: {
		iconName: 'circleXFilled',
		iconFillColor: 'icon/primary/disabled',
		label: 'Discarded',
	},
	[AUTOMATION_JOB_STATUS.PENDING]: {
		iconName: 'clock',
		iconColor: 'icon/info/default',
		label: 'Pending',
	},
	[AUTOMATION_JOB_STATUS.APPLYING]: {
		iconName: 'refresh',
		iconColor: 'icon/info/default',
		label: 'Syncing approved updates',
	},
};

export function AutomationRunStatusBadge({ status }: { status: string }) {
	const iconConfig = StatusColorMap?.[status as AUTOMATION_JOB_STATUS] ?? {
		iconName: 'alertCircleFilled',
		iconColor: 'icon/critical/default',
		label: 'Unknown error',
	};

	return (
		<Group spacing="2xs">
			<Icon
				name={iconConfig.iconName}
				color={iconConfig.iconColor}
				fillColor={iconConfig.iconFillColor}
			/>
			<Text size="sm">{iconConfig.label}</Text>
		</Group>
	);
}
